

export default {
    name: "LinkSpot",
    props: {
        scrapedLinkData: Object
    },
    setup(props){
        return {
            props : props.scrapedLinkData
        }
    }
}